import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootStoreState } from '../../../store/state';

@Component({
  selector: 'newsletter-error-page',
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorPageComponent {  

  constructor(
    // eslint-disable-next-line @ngrx/no-typed-global-store
    private readonly store: Store<RootStoreState>,
  ) {

  }

  reloadApp() {
    // Navigate to root and reload the application
    window.location.href = '/';
  }  
}
